// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vx_N1kEsWmuyzy4us3o7{font-size:16px}`, "",{"version":3,"sources":["webpack://./../@depmap/slice-table/src/styles/FilterModal.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".content {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Vx_N1kEsWmuyzy4us3o7`
};
export default ___CSS_LOADER_EXPORT___;
